import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import user from './modules/user'
import notification from './modules/notification'
import plan from './modules/plan'
import report from './modules/report'
import support from './modules/support'
import versionControl from './modules/version-control'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    user,
    notification,
    plan,
    report,
    support,
    versionControl,
  },
  state: {
    controls: {
      showDrawer: true,
    },
  },
  mutations: {
    toggleDrawer(state, value) {
      state.controls.showDrawer = value
    },
  },
})
